export const MODAL_STYLE = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 550,
    height:'auto',
    maxHeight:"600px",
    // overflow:'scroll',
    bgcolor: 'background.paper',
    borderRadius : "5px",
    boxShadow: 24,
    p: 4,
};
export const DATE_FORMAT = 'MMM D, Y'
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
// Shared loader config — all components must use the same id and libraries to avoid Loader conflict
export const GOOGLE_MAPS_LIBRARIES = ["places"];
export const GOOGLE_MAPS_LOADER_ID = "google-map-script";
export const BASE_URL = process.env.REACT_APP_BASE_URL|| 'http://localhost:5000/';
export const DOWNLOAD_APP_URL = process.env.REACT_APP_DOWNLOAD_LINK;
export const ANALYSIS_URL= process.env.REACT_APP_ANALYSIS_URL;
// export const BASE_URL = 'https://localhost:5001/api/v1/';

export const FIREBASE_API_KEY = process.env.REACT_APP_API_KEY;
export const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_PROJECT_ID;
export const FIREBASE_STORAGE_BUCKET = process.env.REACT_APP_STORAGE_BUCKET;
export const FIREBASE_MESSAGING_SENDER_ID = process.env.REACT_APP_MESSAGING_SENDER_ID;
export const FIREBASE_APP_ID = process.env.REACT_APP_APP_ID;
export const FIREBASE_MEASUREMENT_ID = process.env.REACT_APP_MEASUREMENT_ID;
export const DEFAULT_PAGE = 1;
export const DEFAULT_SEARCH = '';
export const DEFAULT_CITY = 1;
export const DEFAULT_STATUS = 1;
export const DEFAULT_PAGE_SIZE = 10;
